import Header from '../../../../Components/Header'
import Lpntable from './Components/Lpn-table'
import { Helmet } from 'react-helmet'

const ZoneMaster = () => {
  return (
    <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
      <Helmet>
				<title>Zone List</title>
			</Helmet>
        <Header/>
        <Lpntable/>
    </div>
  )
}

export default ZoneMaster